module.exports = __webpack_public_path__ + "media/images/athletes/603-1ece443912cc9ac6ec2cee39940d983f.png";